import { axiosInstance as CloudApiInstance } from "../../APIS";

export const fetchAllUsers = async () => {
  const response = await CloudApiInstance.get(`/users`);
  return response?.data?.data?.users || [];
};

export const updateUser = async (userId, userData) => {
  const response = await CloudApiInstance.put(`/users/${userId}`, userData);
  return response?.data;
}

export const createUser = async (userData) => {
  const response = await CloudApiInstance.post(`/users`, userData);
  return response?.data;
}

export const fetchAllServices = async (filters) => {
  let url = `/services`
  if (filters.is_active) {
    url += `?is_active=${filters.is_active}`;
  }
  const response = await CloudApiInstance.get(url);
  return response?.data?.data?.services || [];
}